import { connect } from 'react-redux'

import ReduxStore from '../../interfaces/client/ReduxStore'
import SelectOptionInterface from '../../interfaces/client/SelectOption'

import getLabels from '../../utils/getLabels'

import SelectField from '../../components/SelectField'

interface GenderSelectPropsInterface {
  isRequired: boolean
  inputName: string
  refName: string
  isDisabled: boolean
  defaultValue?: string
}

export const genderOptions: SelectOptionInterface[] = [
  {
    label: getLabels('male'),
    value: 'Male',
    disabled: false,
  },
  {
    label: getLabels('female'),
    value: 'Female',
    disabled: false,
  },
]

export const mapStateToProps = (
  _state: ReduxStore,
  props: GenderSelectPropsInterface
) => ({
  initialValue: props.defaultValue || '',
  options: genderOptions,
  isRequired: props.isRequired,
  inputName: props.inputName,
  refName: props.refName,
  isDisabled: props.isDisabled,
})

export default connect(mapStateToProps)(SelectField)
